import AbstractView from "abstracts/AbstractView";
import ContactEmail from "./ContactEmail";


export default class ContactEmails extends AbstractView {
	constructor( $wrapper ) {
		super();
		this.$wrapper = $wrapper;
		this.init();
	}
	
	
	initDOM() {
		this.$emails = this.$wrapper.find( '.email-copy_link' )
	}
	
	
	initEl() {
		super.initEl();
		Array.from( this.$emails ).forEach(
			email => {
				new ContactEmail( email, this );
			}
		)
	}
}
